import { yupResolver } from '@hookform/resolvers/yup';
import { DialogActions } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { ICustomField } from 'wisestep-api';
import { WsButton } from 'wisestep-base';

import { WsCustomFieldForm } from '../../../components/BaseCustomField/WsCustomFieldForm';
import { CustomFormProps } from '../../../features/clientsSettings/components/ClientCustomFieldForm';
import {
  customFieldFormSchema,
  submitCustomField,
} from '../../../features/clientsSettings/helper/ClientSettingsHelper';
import { useNotificationStore } from '../../../utils/NotificationStore';

interface FieldFormData extends Omit<ICustomField, 'options'> {
  options: { value: string }[];
}

export const CrmJobCustomFieldForm = ({
  defaultValues,
  onSave,
  onClose,
  entityType,
  title,
  createService,
  updateService,
}: CustomFormProps) => {
  const form = useForm<FieldFormData>({
    defaultValues,
    resolver: yupResolver(customFieldFormSchema),
  });

  const notify = useNotificationStore((state) => state.setNotification);

  const onSubmit = async (formData: FieldFormData) => {
    await submitCustomField({
      entityType,
      formData,
      createService,
      updateService,
      onSave: () => onSave(formData),
      notify,
    });
  };
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <WsCustomFieldForm entityType={entityType} title={title} />
        <DialogActions>
          <WsButton onClick={onClose}>Cancel</WsButton>
          <WsButton type="submit" variant="contained">
            Submit
          </WsButton>
        </DialogActions>
      </form>
    </FormProvider>
  );
};
